'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('LoginCtrl', LoginCtrl);

  LoginCtrl.$inject = ['$scope', 'Auth', 'errorMessageService', '$timeout', '$state',
    'Constants', 'Help', 'Labels', 'Menu', '$mdDialog'];

  function LoginCtrl ($scope, Auth, errorMessageService, $timeout, $state,
    Constants, Help, Labels, Menu, $mdDialog) {

    // redirect to '/project/all' if already loggedIn
    if (Auth.isLoggedIn()) {
      return Promise.all([
        Constants.getConstants(),
        Help.getHelp(),
        Menu.getMenu(),
      ]).then(() => {
        $state.go('project');
      });
    }

    $scope.excludeBrowser = {
      browser: 'ie',
      version: '11.'
    };

    $scope.user = {};
    $scope.errors = {
      errorStatus: false
    };

    $scope.LABELS = Labels;

    $scope.formStatus = {
      type: 'alert-success',
      message: ''
    };

    $scope.submitted = false;
    $scope.resetPasswordProcedure = false;

    $scope.onLoginInputChange = function () {
      $scope.formStatus.message = '';
      $scope.submitted = false;
    };

    $scope.login = function (form) {
      if ($scope.resetPasswordProcedure) {
        return;
      }

      $scope.submitted = true;

      if (form.$valid) {
        Auth.login({
          email: $scope.user.email,
          password: $scope.user.password
        })
          .then(function () {
            $scope.hideMenu = true;

            // Users with 2 or more databases should be redirected to the tenants/all page,
            // Otherwise redirect them directly to the project/all page.
            $scope.redirectUser = Auth.getCurrentUser().databases.length <= 1 ?  'project' : 'tenants/all';

            $timeout(function () {
              $state.go($scope.redirectUser); // project|tenants/all
            }, 250);
          })
          .catch(function () {
            $scope.errors.errorStatus = true;

            // Display a general error using the mdDialog
            if ($scope.errors.errorStatus) {
              const invalidCredentials = $mdDialog.alert()
                .clickOutsideToClose(true)
                .title($scope.LABELS.getPlural('wrongcredential'))
                .textContent($scope.LABELS.getPlural('wrongcredential'))
                .ok('Opnieuw proberen');

              $mdDialog.show(invalidCredentials).then(() => {
                $scope.errors.errorStatus = false;
              });
            }

            $state.go('logout');
          });
      }
    };
    /**
     * Functions shown here are trigger by manualTransactionalEmail('func')
     * The promises are being handled by the manualTransactionEmail()
     *
     * @param {String} email this will be the receipient
     */
    $scope.requestNewPasswordPromise = (email) => Auth.sendPasswordByEmail(email);

    $scope.requestActivationEmailPromise = (email) => Auth.reactivateUserByMail(email);

    /**
     * Function handles type of "transactional message" that needs to be sent
     *
     * @param {String} type defines which function should be called
     * @param {Object} msg contains the messages that can be used on the front-end
     */
    $scope.manualTransactionalEmail = (type) => {
      if (Object.keys($scope.user.email).length > 0) {

        const promise = $scope[`${type}Promise`].apply(null, [$scope.user.email]);

        promise.then((res) => {
          if (res.data.status === 'fail') {
            throw new Error(res.data.error && res.data.error.msg);
          }

          const sentTo = $scope.LABELS.getLabel('activationemailsentto');
          const fourteenDays = $scope.LABELS.getLabel('changepasswordinfourteendays');
          const msg = `${sentTo}: ${$scope.user.email}\n${fourteenDays}`;
          const close = $scope.LABELS.getLabel('close');

          // Close the toast message and return to the log in screen
          errorMessageService.showToast(msg, true);
          $scope.switchForm('login');
        })
          .catch((error) => {
            /*
              When failed make sure to display a toast message. The toast message
              should remain visible until success
            */
            $scope.errors.errorStatus = true;
            const serverMsg = $scope.LABELS.getLabel('somethingwentwrongemail');
            if ($scope.errors.errorStatus) {
              // Using errorMessageService to show the toast message
              if (error.error.msg !== 'user not activated' && error.error.msg !== 'user not found') {
                errorMessageService.showToast(serverMsg, true);
              }
            }
          });
      }
    };

    $scope.reset = function (form) {
      if (form) {
        form.$setPristine();
        form.$setUntouched();
        $scope.user.email = '';
        $scope.user.password = '';
        $scope.submitted = false;
        $scope.formStatus.message = undefined;
      }
    };

    $scope.switchForm = function (to) {
      $scope.reset($scope.form);
      $scope.resetPasswordProcedure = (to === 'forgot');
    };
  }

})();
